import { render, staticRenderFns } from "./FactorGroup.vue?vue&type=template&id=93302f90&scoped=true&lang=pug"
import script from "./FactorGroup.vue?vue&type=script&lang=js"
export * from "./FactorGroup.vue?vue&type=script&lang=js"
import style0 from "./FactorGroup.vue?vue&type=style&index=0&id=93302f90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93302f90",
  null
  
)

export default component.exports